module.exports = __webpack_public_path__ + "static/media/searchClose.07341bc4.svg";